<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">No de Declaraciones</h4>
        <div class="row">

          <div v-if="rol != 4" class="col-md-4">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias1" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <label>Desde</label><br>
            <el-date-picker name="fecha_inicio" v-model="model.fecha_inicio" format="dd-MM-yyyy" value-format="yyyy-MM-dd" type="date" placeholder="Elige un día">
            </el-date-picker>
          </div>
          <div class="col-md-4">
            <label>Hasta</label><br>
            <el-date-picker name="fecha_fin" v-model="model.fecha_fin" format="dd-MM-yyyy" value-format="yyyy-MM-dd" type="date" placeholder="Elige un día">
            </el-date-picker>
          </div>
          <div class="col-md-12">
            <label></label><br>
            <div class="row">
              <div class="col-sm-12">
                <button @click="getDeclaracionesR" class="btn btn-fill btn-success " style="text-align:left">
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <br>
          <div class="row">
            <div class="col-sm-6">

              <export-excel class="btn btn-wd btn-success" :data="list_cumplimiento" :meta="meta" :fields="no_declaraciones" worksheet="Resumén declaraciones" name="Resumén declaraciones.xls">
                <span class="btn-label">
                  <i class="fa fa-file-excel"></i>
                </span>
                Descargar Reporte
              </export-excel>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
              <b-form-group>
                <b-input-group>
                  <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <v-data-table :headers="headers" :items="list_cumplimiento" :items-per-page="5" :search="filter" class="" :fixed-header="true">

                <template v-slot:item.t_inicial="{ item }">
                  <v-progress-circular :rotate="360" :size="70" :width="5" :value="item.l_inicial" color="teal">
                    <strong>{{ item.r_iniciales }}</strong>
                  </v-progress-circular>
                </template>
                <template v-slot:item.t_anual="{ item }">
                  <v-progress-circular :rotate="360" :size="70" :width="5" :value="item.l_anual" color="teal">
                    <strong>{{ item.r_anuales }}</strong>
                  </v-progress-circular>
                </template>
                <template v-slot:item.t_final="{ item }">
                  <v-progress-circular :rotate="360" :size="70" :width="5" :value="item.l_final" color="teal">
                    <strong>{{ item.r_finales }}</strong>
                  </v-progress-circular>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  Table,
  TableColumn,
  Select,
  Option,
  DatePicker
} from 'element-ui'
import PPagination from 'src/components/UIComponents/Pagination.vue'

export default {
  components: {
    PPagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker
  },
  data () {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        dependencia_id1: '',
        periodo: ''
      },
      rol: '',
      filter: null,
      list_cumplimiento: [],
      meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],

      no_declaraciones: {
        'Dependencia': 'dependencia',
        'Total Iniciales': 'r_iniciales',
        'Total Anuales': 'r_anuales',
        'Total Finales': 'r_finales'
      },
      headers: [{
        text: 'Dependencia',
        align: '',
        value: 'dependencia'
      }, {
        text: 'Total Iniciales',
        value: 't_inicial',
        align: 'center'
      }, {
        text: 'Total Anuales',
        value: 't_anual',
        align: 'center'
      },
      {
        text: 'Total Finales',
        value: 't_final',
        align: 'center'
      }
      ]
    }
  },
  computed: {
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions () {
      let permiso = [1]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    getDeclaracionesR () {
      this.model.estatus = 0
      this.model.tipo_declaracion = 4
      this.model.periodo = new Date().getFullYear()

      this.$http.post('repndeclaraciones', this.model).then(
        response => {
          this.list_cumplimiento = []
          response.data.forEach((value, key) => {
            var obj = {
              dependencia: value.dependencia ? value.dependencia : '',
              cumplidos: value.cumplidos ? value.cumplidos : 0,
              obligados_iniciales: value.obligados_iniciales ? value.obligados_iniciales : 0,
              obligados_anuales: value.obligados_anuales ? value.obligados_anuales : 0,
              obligados_finales: value.obligados_finales ? value.obligados_finales : 0,
              r_iniciales: value.r_iniciales ? value.r_iniciales : 0,
              r_anuales: value.r_anuales ? value.r_anuales : 0,
              r_finales: value.r_finales ? value.r_finales : 0,
              l_inicial: 0,
              l_anual: 0,
              l_final: 0
            }

            if (value.obligados_iniciales > 0 && value.r_iniciales > 0) {
              obj.l_inicial = value.r_iniciales * 100 / value.obligados_iniciales
            }
            if (value.obligados_anuales > 0 && value.r_anuales > 0) {
              obj.l_anual = value.r_anuales * 100 / value.obligados_anuales
            }
            if (value.obligados_finales > 0 && value.r_finales > 0) {
              obj.l_final = value.r_finales * 100 / value.obligados_finales
            }

            this.list_cumplimiento.push(obj)
          })
        },
        error => {
          this.StepError(error)
        }
      )
    }
    // getDependencias() {
    //   var v = this
    //   this.$http.get('cat_ente_publico').then(
    //     response => {
    //       this.dependencias = response.data.entes_publicos
    //       this.dependencias.unshift({
    //         'codigo': 'T',
    //         'id': 0,
    //         'valor': 'Todas'
    //       })
    //     },
    //     error => {
    //       this.StepError(error)
    //     }
    //   )
    // }
  },
  created () {
    // this.getDependencias()
    this.rol = this.getKey('role')
    this.checkPermissions()
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/RepDeclaraciones2.vue